
import { defineComponent, reactive, toRefs, computed, Ref } from "vue";
import { useLicencaOrgaoService } from "../../../modules/business/licenca/licencaOrgaoBusiness";
import { ImportacaoDocumentoReturn } from "../../../modules/business/veiculo/importacaoVeiculoBusiness";
import { useToast } from "../../../modules/message";

interface ImportacaoAetAgetoState {
  importReturn: ImportacaoDocumentoReturn | null;
  imported: boolean;
  stateId: string;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  props: {
    // preenchidos: importa so a AET do registro Tocantins informado
    idLicenca: Number,
    idLicencaOrgao: Number,
    parentLoading: Boolean
  },
  setup(props, { emit }) {
    const state = reactive<ImportacaoAetAgetoState>({
      importReturn: null,
      imported: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      loadings: []
    });

    const isIndividual = computed(
      () => !!(props.idLicenca && props.idLicencaOrgao)
    );

    const stateLoading = computed(() => {
      return state.loadings.length !== 0 || props.parentLoading;
    });

    const closeScreen = () => {
      emit("after-import", state.imported);
    };

    const clearFile = () => {
      const file = document.querySelector(
        "#" + state.stateId + "_importacao"
      ) as HTMLInputElement;
      if (file) {
        file.value = "";
      }
    };

    const submitSave = () => {
      state.importReturn = null;
      const file = document.querySelector(
        "#" + state.stateId + "_importacao"
      ) as HTMLInputElement;
      if (!file || !file.files || file.files.length === 0) {
        useToast().warning("É necessário um arquivo.");
        return;
      }
      // enviado direto ao endpoint: o PDF da AGETO passa do limite de 4MB do /storage/temp
      const formData = new FormData();
      formData.append("file", file.files[0]);

      const {
        importAetAgeto,
        importAetAgetoLote,
        loading,
        data
      } = useLicencaOrgaoService();
      state.loadings.push(loading);
      (isIndividual.value
        ? importAetAgeto(
            props.idLicenca as number,
            props.idLicencaOrgao as number,
            formData
          )
        : importAetAgetoLote(formData)
      )
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          clearFile();
          // lote e individual devolvem o mesmo retorno; o individual pode trazer o aviso das
          // carretas de rodizio que nao constam na AET, entao o modal fica aberto com o resultado
          state.importReturn = data.value;
          if (!state.importReturn) {
            useToast().warning("Não foi possível realizar a importação.");
          } else {
            state.imported = !!state.importReturn.sucesso?.length;
            if (state.importReturn.erros && state.importReturn.erros.length) {
              useToast().warning(
                "Arquivo processado com erros. Verifique o retorno."
              );
            } else {
              useToast().success("Importação realizada com sucesso.");
            }
          }
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    return {
      isIndividual,
      stateLoading,
      closeScreen,
      submitSave,
      ...toRefs(state)
    };
  }
});
